module.exports = __webpack_public_path__ + "static/media/Logo-vidalta.7487f4f7.jpg";